import React from "react";

const Paragraph = ({ children, color, classe, maxWidth, size, onClick }) => {
  let theme, sizeP;

  if (color === "light") theme = "text-smoot";
  else theme = "text-secondary";

  if (size === "small") sizeP = "text-xs md:text-sm";
  else sizeP = "text-sm md:text-base";

  return (
    <p
      className={`${classe} ${theme} ${sizeP}  leading-relaxed ${
        maxWidth ? "paraWidth" : ""
      } font-nunito `}
      onClick={onClick}
    >
      {children}
    </p>
  );
};

export default Paragraph;
